import { Transition } from '@uirouter/core';
import { ISCEService, IScope, ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import UtilService from '../../common/services/util.service';
import { CardDeleteAction } from '../../buy/card-delete-dialog/card-delete-dialog.action';
import { PaymentMethod } from '../../buy/services/payment-method.model';
import { PaycellService } from '../../buy/services/paycell.service';
import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import { DeleteCreditCardEvent } from '../../common/services/analytics/events/dimensions';


import { OpenUserRegistrationAction } from './family-plan-user-registration-dialog.action';

import { IPromise, IWindowService } from 'angular';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

/* @ngInject */
export default class FamilyPlanUserRegistrationDialogController implements ActionHandler {
  private dialogElement;
  private type: FamilyPlanTypes;
  // protected card: PaymentMethod;
  // protected onDeleteSuccess: (paymentMethodID) => any;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $state,
    private $scope: IScope,
    private $timeout: ITimeoutService,
    private paycellService: PaycellService,
    private googleAnalytics: GoogleAnalyticsService,
    private $window: IWindowService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#family-plan-user-registration-dialog').remodal();

  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenUserRegistrationAction) {
      this.type = action.type;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public onGoInfo() {
    this.close();
    if(this.isDuoPackage()){
      this.$state.go('duoPlanInfo');
    } else{
      this.$state.go('familyPlanInfo');
    }
  }

  public isActive(destination: string) {
    return destination === this.$window.location.pathname;
  }

  private close() {
    this.dialogElement.close();
  }

  public onClose() {
    this.close();
    this.$state.go('myAccount');
  }
  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-user-registration-dialog/family-plan-user-registration-dialog.controller.ts